export const i18nScope = 'fa.feature-gallery';
